'use client';

import { useEffect, useState } from 'react';

/**
 * SSR-safe „már hidratáltunk?" jelző.
 *
 * A Next.js App Router szerver-oldalon nem ismeri a `localStorage`-ot, így a
 * Zustand-Persist `useAuth().isAuthenticated()` `false`-t ad vissza. A kliensen
 * viszont a Persist a hidratálás közben betölti a token-t, és onnan a hook
 * `true`-t ad — ez DOM-eltérést okoz (React `Hydration failed`).
 *
 * Mintázat: a komponensben tartsd meg az SSR-default (bejelentkezetlen) UI-t
 * az első renderben, és csak akkor válts az auth-állapot szerinti UI-ra,
 * ha `hydrated === true`.
 *
 * ```tsx
 * const hydrated = useHydrated();
 * const isLogged = useAuth(s => s.isAuthenticated());
 * if (!hydrated || !isLogged) return <Login/Sigup buttons />;
 * return <AvatarDropdown />;
 * ```
 */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => setHydrated(true), []);
  return hydrated;
}
